<template>
  <div
    v-loading.fullscreen.lock="isSubmitting"
    :element-loading-text="$t('Submitting...')"
    class="biller-user-form-page page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <el-button type="text"
                   icon="el-icon-back"
                   class="back-button"
                   @click.prevent="goBack">
        </el-button>
        <h2 class="page-title">{{ isUpdated ? 'แก้ไขบัญชีผู้ดูแลบริษัท' : 'เพิ่มบัญชีผู้ดูแลบริษัท' }}</h2>
      </el-col>
    </el-row>

    <el-form
      :model="adminForm"
      :rules="adminFormRules"
      ref="adminForm"
      label-width="120px"
      label-position="top"
      @submit.native.prevent="submitForm('adminForm')"
      :disabled="isSubmitting"
      class="admin-form company-detail-info">
      <el-row>
        <el-col :span="10">
          <el-form-item label="อีเมลผู้ดูแล" prop="email">
            <el-input
              v-model="adminForm.email"
              id="adminForm.email"
              :disabled="adminForm.role === 'ADMIN'"
              placeholder="กรอกอีเมลผู้ดูแล"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="ชื่อผู้ดูแล" prop="name">
            <el-input
              v-model="adminForm.name"
              id="adminForm.name"
              :disabled="adminForm.role === 'ADMIN'"
              placeholder="กรอกชื่อผู้ดูแล"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="หมายเลขโทรศัพท์" prop="tel">
            <el-input
              v-model="adminForm.tel"
              id="adminForm.tel"
              :disabled="adminForm.role === 'ADMIN'"
              placeholder="กรอกหมายเลขโทรศัพท์"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="สถานะบัญชี" prop="status">
            <el-checkbox
              v-model="adminForm.status"
              :disabled="adminForm.role === 'ADMIN'"
              id="adminForm.status">Enable</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="รายละเอียดผู้ดูแล" prop="description">
            <el-input
              v-model="adminForm.description"
              id="adminForm.description"
              :disabled="adminForm.role === 'ADMIN'"
              placeholder="กรอกรายละเอียดผู้ดูแล"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--
      <el-row>
        <el-col :span="10">
          <el-form-item label="หน้าที่" prop="role">
            <el-radio-group v-model="adminForm.role">
              <el-radio
                label="ADMIN"
                id="adminForm.role_1">Admin</el-radio>
              <el-radio
                label="STAFF"
                id="adminForm.role_2">Staff</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      -->
      <el-row class="detail-section assigned-profiles-section" v-if="adminForm.role !== 'ADMIN'">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ข้อมูลรับชำระบริษัทที่ดูแล</h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="assign-as-staff-holder">
            <el-select
              v-model="assignStaffList"
              class="assign-as-staff"
              placeholder="Assign same as staff"
              @change="assignAsStaff">
              <el-option
                v-for="item in allStaffs"
                :key="`staff_${item.id}`"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-form-item label="" prop="assigned_profiles">
              <el-select v-model="adminForm.assigned_profiles" multiple style="display:none;">
                <el-option
                  v-for="id, $index in adminForm.assigned_profiles"
                  :key="`profile_${$index}_${id}`"
                  :label="id"
                  :value="id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="profile-list-table">
              <el-table
                ref="multipleTable"
                :data="profileListData"
                :default-sort = "{prop: 'name', order: 'ascending'}"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  fixed="left"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="ชื่อ"
                  class-name="no-wrap"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="ข้อมูล Bill Payment"
                  header-align="center"
                  align="center">
                  <el-table-column
                    prop="bill_payment_comp_code"
                    label="COMP CODE"
                    header-align="center"
                    align="center"
                    sortable
                    :formatter="compCodeFormatter"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="bill_payment_account_no"
                    label="หมายเลขบัญชี"
                    header-align="center"
                    align="center"
                    sortable
                    :formatter="accountNoFormatter"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="bill_payment_biller_id"
                    label="Biller ID"
                    header-align="center"
                    align="center"
                    sortable
                    :formatter="billerIdFormatter"
                    width="130">
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  prop="payment_type"
                  label="วิธีการชำระเงิน"
                  sortable
                  header-align="center"
                  align="center"
                  width="140"
                  :formatter="paymentTypeFormatter">
                </el-table-column>
                <el-table-column
                  prop="update_at"
                  label="วันที่แก้ไข"
                  width="120"
                  header-align="center"
                  align="center"
                  sortable
                  :formatter="dateFormatter">
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="button-bar">
            <el-button
              type="primary"
              plain
              class="cancel-btn"
              @click="goBack"
              id="adminForm.cancelButton">{{ 'Cancel' | translate }}</el-button>
            <div class="submit-button-group">
              <el-button
                type="danger"
                class="terminate-btn"
                icon="el-icon-delete"
                v-if="isUpdated && adminForm.role === 'STAFF'"
                @click="confirmTerminate"
                id="adminForm.terminateButton">{{ 'Terminate' | translate }}</el-button>
              <el-button
                type="primary"
                id="adminForm.submitButton"
                icon="el-icon-edit"
                v-if="adminForm.role === 'STAFF'"
                native-type="submit">{{ isUpdated ? 'แก้ไขบัญชี' : 'สร้างบัญชี' }}</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  /* eslint no-param-reassign: 0 */
  import helpers from '@/libs/helpers';
  import _ from 'lodash';
  import moment from 'moment-timezone';
  import { createMask } from 'imask';
  /**
   * Biller User Form view
   */
  const BillerUserFormView = {
    name: 'biller-user-form',
    props: ['userId'],
    data() {
      return {
        isSubmitting: false,
        isSetupUpdateData: false,
        assignStaffList: [],
        adminForm: {
          email: '',
          name: '',
          tel: '',
          status: true,
          description: '',
          role: 'STAFF', // "ADMIN", "STAFF",
          assigned_profiles: [],
        },
        adminFormRules: {
          email: [
            { required: true, message: 'กรุณากรอกอีเมลผู้ดูแล', trigger: 'blur' },
            { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' },
          ],
          name: [
            { required: true, message: 'กรุณากรอกชื่อผู้ดูแล', trigger: 'blur' },
          ],
          tel: [
            { message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' },
          ],
          /* description: [
            { required: true, message: 'กรุณากรอกรายละเอียดผู้ดูแล', trigger: 'blur' },
          ], */
          assigned_profiles: [
            { validator: this.checkAssignedProfiles, message: 'กรุณาเลือกข้อมูลรับชำระเงินของบริษัทที่ให้พนักงานดูแล', trigger: 'blur' },
          ],
        },
        mask: {
          tel: {
            mask: [
              { mask: '{02}-000-0000' },
              { mask: '{0}00-000-000' },
              { mask: '{0}00-000-0000' },
            ],
          },
          compCode: {
            mask: /^\d{0,4}$/,
          },
          accountNo: {
            mask: '000-0-00000-0',
          },
          billerId: {
            mask: /^\d{0,15}$/,
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isUpdated() {
        return typeof this.userId !== 'undefined';
      },
      companyId() {
        return this.$store.getters.billerInfo.id;
      },
      profileListData() {
        return this.$store.getters.billerProfileList;
      },
      allStaffs() {
        let billerUserList = [];
        if (this.userId) {
          const uid = parseInt(this.userId, 10);
          billerUserList = this.$store.getters
            .billerUserList.filter(user => user.id !== uid);
        } else {
          billerUserList = this.$store.getters.billerUserList;
        }
        return billerUserList.filter(user => user.role === 'STAFF');
      },
      userInfo() {
        if (this.isUpdated) {
          /* const indexId = `_${this.userId}`;
          if (typeof this.$store.getters.billerUserListIndex[indexId] !== 'undefined') {
            const idx = this.$store.getters.billerUserListIndex[indexId];
            return this.$store.getters.billerUserList[idx];
          } */
          let userInfo = null;
          this.$store.getters.billerUserList.forEach((item) => {
            if (item.id === this.userId) {
              userInfo = item;
            }
          });
          return userInfo;
        }
        return null;
      },
    },
    methods: {
      goBack() {
        this.$router.push({
          name: 'BillerUserList',
        });
      },
      confirmTerminate() {
        this.$confirm('ท่านกำลังจะลบบัญชีผู้ดูแลบริษัทนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
          confirmButtonText: this.$t('Confirm'),
          confirmButtonClass: 'danger-btn',
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(() => {
          this.isSubmitting = true;
          this.$store.dispatch('DELETE_BILLER_USER_INFO', this.userId).then(() => {
            this.isSubmitting = false;
            this.$message({
              type: 'success',
              showClose: true,
              duration: 10000,
              message: 'ลบข้อมูลผู้ดูแลบริษัทสำเร็จแล้ว',
            });
            this.goBack();
          }).catch((msg) => {
            this.isSubmitting = false;
            if (msg) {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
            } else {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
            }
          });
        }).catch(() => {
        });
      },
      checkAssignedProfiles(rule, value, cb) {
        if (this.adminForm.assigned_profiles.length === 0) {
          cb(new Error());
        } else {
          cb();
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate(this.validateForm);
      },
      validateForm(valid) {
        if (!valid) {
          this.$log.error('error submit!!');
          return false;
        }
        this.isSubmitting = true;
        const action = this.isUpdated ? 'UPDATE_BILLER_USER_INFO' : 'CREATE_BILLER_USER_INFO';
        const payload = JSON.parse(JSON.stringify(this.adminForm));
        // transform payload's status
        // transform payload
        // this.unmaskValue(payload, 'tel', this.mask.tel);
        payload.status = payload.status ? 'active' : 'inactive';
        delete payload.created_at;
        delete payload.update_at;
        const reqPayload = {
          payload,
        };
        if (this.isUpdated) {
          reqPayload.userId = payload.id;
        } else {
          reqPayload.companyId = this.companyId;
        }
        this.$store.dispatch(action, reqPayload).then(() => {
          this.isSubmitting = false;
          let successMessage = 'สร้างบัญชีผู้ดูแลบริษัทใหม่สำเร็จแล้ว';
          if (this.isUpdated) {
            successMessage = 'แก้ไขข้อมูลบัญชีผู้ดูแลบริษัทสำเร็จแล้ว';
          }
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: successMessage,
          });
          this.goBack();
        }).catch((msg) => {
          this.isSubmitting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
        return true;
      },
      setupUpdateData() {
        this.isSetupUpdateData = true;
        if (this.userInfo) {
          Object.keys(this.userInfo).forEach((key) => {
            if (key === 'status') {
              const isActive = this.userInfo[key] === 'active';
              this.$set(this.adminForm, key, isActive);
            } else if (key === 'assigned_profiles') {
              if (this.profileListData) {
                // remove duplicate key
                const userKeys = {};
                this.userInfo.assigned_profiles.forEach((id) => {
                  if (!userKeys[id]) {
                    userKeys[id] = id;
                  }
                });
                this.adminForm.assigned_profiles.splice(0);
                this.profileListData.forEach((row) => {
                  if (userKeys[row.id]) {
                    this.adminForm.assigned_profiles.push(row.id);
                    if (this.$refs.multipleTable) {
                      this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                  }
                });
              }
            } else {
              this.$set(this.adminForm, key, this.userInfo[key]);
            }
          });
          this.$nextTick(() => {
            // this.updateMaskTel();
            this.updateProfileTable();
          });
        }
      },
      clearUpdateData() {
        this.isSetupUpdateData = false;
        this.adminForm.email = '';
        this.adminForm.name = '';
        this.adminForm.tel = '';
        this.adminForm.status = true;
        this.adminForm.description = '';
        this.adminForm.role = 'STAFF';
        this.adminForm.assigned_profiles.splice(0);
      },
      paymentTypeFormatter(row) {
        return row.payment_type === 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : 'เช็ค/เงินสด';
      },
      dateFormatter(row, column, cellValue) {
        const date = moment(cellValue).tz(process.env.DEFAULT_TZ);
        if (date.isValid()) {
          return date.format('ll');
        }
        return '-';
      },
      handleSelectionChange(val) {
        // adminForm
        this.adminForm.assigned_profiles.splice(0);
        val.forEach((item) => {
          this.adminForm.assigned_profiles.push(item.id);
        });
      },
      assignAsStaff(value) {
        const key = `_${value}`;
        if (typeof this.$store.getters.billerUserListIndex[key] !== 'undefined') {
          const idx = this.$store.getters.billerUserListIndex[key];
          if (typeof this.$store.getters.billerUserList[idx] !== 'undefined') {
            const user = this.$store.getters.billerUserList[idx];
            this.profileListData.forEach((row) => {
              if (user.assigned_profiles.indexOf(row.id) !== -1) {
                if (this.$refs.multipleTable) {
                  this.$refs.multipleTable.toggleRowSelection(row, true);
                }
              }
            });
          }
        }
      },
      updateProfileTable() {
        this.profileListData.forEach((row) => {
          if (this.adminForm.assigned_profiles.indexOf(row.id) !== -1) {
            if (this.$refs.multipleTable) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            }
          }
        });
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      unmaskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          mask.resolve(val.toString());
          form[field] = mask.unmaskedValue;
        }
      },
      /* updateMaskTel() {
        try {
          this.maskValue(this.adminForm, 'tel', this.mask.tel);
        } catch (e) {
          console.error(e);
        }
      }, */
      compCodeFormatter(row, column, cellValue) {
        if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.compCode);
        }
        return '-';
      },
      accountNoFormatter(row, column, cellValue) {
        if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.accountNo);
        }
        return '-';
      },
      billerIdFormatter(row, column, cellValue) {
        if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.billerId);
        }
        return '-';
      },
      maskFormatter(val, maskOptions) {
        const mask = createMask(maskOptions);
        if (val) {
          return mask.resolve(val.toString());
        }
        return '';
      },
      /* eslint prefer-arrow-callback: 0 */
      handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
        helpers.handleInput(evt,
          this.$refs, refName,
          this.mask, maskName);
      }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
    },
    mounted() {
      // load data to form
      if (this.isUpdated) {
        setTimeout(() => {
          if (typeof this.userInfo === 'undefined' || this.userInfo === null) {
            this.goBack();
          }
        }, 1000);
      }
      if (this.isUpdated && this.userInfo) {
        this.setupUpdateData();
      }
    },
    watch: {
      userInfo(newVal) {
        if (this.isUpdated && !this.isSetupUpdateData && newVal) {
          this.setupUpdateData();
        }
      },
      profileListData(newVal) {
        if (this.isUpdated && newVal) {
          this.$nextTick(() => {
            this.setupUpdateData();
          });
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        // Fetch data
        vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
        vm.$store.dispatch('START_CONTENT_LOADING');
        vm.$store.dispatch('GET_BILLER_PROFILE_LIST', vm.$store.getters.billerInfo.id).then(() => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
        }).catch((err) => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
          vm.$store.dispatch('ADD_ERROR_FLASH', err);
        });
      });
    },
    beforeRouteLeave(to, from, next) {
      this.clearUpdateData();
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      next();
    },
  };
  export default BillerUserFormView;
</script>

<style lang="scss">
  .biller-user-form-page {
    .admin-form {
      .assigned-profiles-section {
        .assign-as-staff-holder {
          text-align: right;
        }
        .assign-as-staff {
          text-align: left;
        }
      }
      .cancel-btn, .terminate-btn {
        padding-top: 16px;
        padding-bottom: 16px;
      }
      .submit-button-group {
        float: right;
      }
    }
    .profile-list-table {
      border: 1px solid #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/biller/user-form.vue